import getServiceContextFolderId from 'owa-mail-store/lib/services/utils/getServiceContextFolderId';
import getServiceItemIds from './utils/getServiceItemIds';
import MoveItemRequest from 'owa-service/lib/contract/MoveItemRequest';
import MoveItemResponse from 'owa-service/lib/contract/MoveItemResponse';
import moveItemRequest from 'owa-service/lib/factory/moveItemRequest';
import moveItemOperation from 'owa-service/lib/operation/moveItemOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { getMailboxInfoFromFolderId } from 'owa-mail-mailboxinfo/lib/getMailboxInfo';
import { getMailboxRequestOptions } from 'owa-request-options-types';

/**
 * The service command to move items to a specified destination folder
 * @param itemIds the ids of the items to be moved
 * @param destinationFolderId the id of destination folder to move to
 * @return a Promise which contains the MoveItemResponse
 */
export default function moveItemsService(
    itemIds: string[],
    destinationFolderId: string,
    sourceFolderId: string
): Promise<MoveItemResponse> {
    const requestBody = configureRequestBody(itemIds, destinationFolderId);

    return moveItemOperation(
        {
            Header: getJsonRequestHeader(),
            Body: requestBody,
        },
        getMailboxRequestOptions(getMailboxInfoFromFolderId(destinationFolderId))
    ).then(response => {
        return response.Body;
    });
}

/**
 * Configure the MoveItemRequest body
 * @param itemIds the ids of the items to be moved
 * @param destinationFolderId the id of destination folder to move to
 * @return a Promise which contains the MoveItemResponse
 */
function configureRequestBody(itemIds: string[], destinationFolderId: string): MoveItemRequest {
    return moveItemRequest({
        ToFolderId: getServiceContextFolderId(destinationFolderId),
        ItemIds: getServiceItemIds(itemIds),
        ReturnNewItemIds: true,
    });
}
